import { useEffect, useState } from "react";
import SvgFilepresent from "components/svgs/filepresent";
import SvgDelete from "components/svgs/delete";
import Button from "components/buttons/basic";
import TooltipV2 from "components/tooltip-v2";
import DocumentPreview from "components/modals/documents-preview";
import useTranslation from "hooks/useTranslate.hook";
import SvgSearch from "components/svgs/search";


const imageMimeType = /image\/(png|jpg|jpeg)/i;
const imageNames = /\.(jpe?g|png)$/i;

type AttaclmentImageType = {
    fileProp: any,
    keyProp: any,
    name: any,
    removeFile?: Function,
    displayName: boolean,
    displayDeleteButton?: boolean,
    displayPreviewButton?: boolean,
    allDocs?: Array<any>
}

const AttachmentImage = ({ fileProp, keyProp, name, removeFile, displayName, displayDeleteButton = true, displayPreviewButton = false, allDocs = [fileProp] }: AttaclmentImageType) => {

    const [file, setFile] = useState<any>(null);
    const [fileDataURL, setFileDataURL] = useState<any>();
    const [fileNotImage, setFileNotImage] = useState<boolean>(false);
    const [fileDisplay, setFileDisplay] = useState<boolean>(false);
    const [openDocumentPreview, setDocumentPreviewOpen] = useState<any>({ isOpen: false, selectedDocument: null });
    const { t } = useTranslation();

    const handleDeleteClick = (e: any) => {
        removeFile && removeFile(name);
    }


    useEffect(() => {
        let fileReader: FileReader, isCancel = false;

        if (file) {
            if (!file.type?.match(imageMimeType) && !imageNames.test(file.name ?? '')) {
                setFileNotImage(true);
                setFileDataURL("");
                setFileDisplay(true);
                return;
            }

            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const result = e.target?.result;
                if (result && !isCancel) {
                    setFileDataURL(result);
                    setFileDisplay(true);
                }
            }
            try {
                fileReader.readAsDataURL(file);
            } catch (e) {
                setFileNotImage(true);
                setFileDataURL("");
                setFileDisplay(true);
            }
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }

    }, [file]);

    useEffect(() => {
        setFile(fileProp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {fileDisplay ?
                <div key={keyProp} className="c-communication-email-attachment__attachmnet_list_image">
                    <picture className={fileNotImage ? "c-communication-email-attachment__attachmnet_list_image__wrapper c-communication-email-attachment__attachmnet_list_image__wrapper--file" : "c-communication-email-attachment__attachmnet_list_image__wrapper"}>
                        {fileNotImage ?
                            <SvgFilepresent className="c-communication-email-attachment__attachmnet_list_image__wrapper__filepresnetation"  />
                            :
                            // eslint-disable-next-line @next/next/no-img-element
                            <img src={fileDataURL} alt="" width="40" />
                        }
                        {displayDeleteButton &&
                            <Button
                                shape="circle"
                                color="grey"
                                type="button"
                                size="small"
                                icon={[<SvgDelete key="svg-edit" />]}
                                customClasses="c-communication-email-attachment__attachmnet_list_image__wrapper__delete-button"
                                onClick={() => handleDeleteClick(name)}
                            />
                        }
                        {displayPreviewButton &&
                            <Button
                                shape="circle"
                                color="grey"
                                type="button"
                                size="small"
                                icon={[<SvgSearch key="svg-search" />]}
                                customClasses="c-communication-email-attachment__attachmnet_list_image__wrapper__delete-button"
                                onClick={() => (!!allDocs && allDocs.length > 0) ? setDocumentPreviewOpen({ isOpen: true, selectedDocument: file, documents: allDocs.map((docs: any) => docs.file)}) : setDocumentPreviewOpen({isOpen: true, selectedDocument: file})}
                            />
                        }
                        {openDocumentPreview.isOpen &&
                            <DocumentPreview
                                title={t('cv_preview')}
                                documentsArray={openDocumentPreview.documents}
                                selectedDocument={openDocumentPreview.selectedDocument}
                                isOpen={openDocumentPreview.isOpen}
                                onClose={() => setDocumentPreviewOpen({ isOpen: false, selectedDocument: null })} />}
                    </picture>
                    {displayName &&
                        <TooltipV2 text={file?.name} customClass="c-communication-email-attachment__attachmnet_list_image__name__tooltip">
                            <div className="u-ellipsis c-communication-email-attachment__attachmnet_list_image__name">
                                {file?.name}
                            </div>
                        </TooltipV2>
                    }
                </div>
                : null}
        </>
    )
};

export default AttachmentImage;